import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WarrentyCheck = Loadable(lazy(() => import("./WarrentyCheck")));

const WarrentyCheckRoutes = [
  { path: "/asset/warrenty-check", element: <WarrentyCheck /> },
];

export default WarrentyCheckRoutes;
